import React from 'react';
import {useField} from 'formik';

import {useMediaQuery} from 'src/hooks/useMediaQuery';

import Fieldset from 'shared/components/fieldset';
import Score from './score';

import styles from './scores.module.scss';

interface Props {
  min: number;
  max: number;
  step?: number;
  customRanges?: Record<
    string,
    {
      min: number;
      max: number;
      step: number;
    }
  >;
  optionalFields?: string[];
  tooltips?: Record<string, string>;
}

const Scores = ({
  min,
  max,
  step = 1,
  customRanges = {},
  optionalFields = [],
  tooltips = {},
}: Props) => {
  const mq = useMediaQuery();
  const [field] = useField('scores');

  const scores = Object.keys(field.value).map((scoreName) => {
    const range = customRanges[scoreName] || {min, max, step};

    return (
      <Score
        key={scoreName}
        name={scoreName}
        min={range.min}
        max={range.max}
        step={range.step}
        optional={optionalFields.includes(scoreName)}
        tooltip={tooltips[scoreName]}
      />
    );
  });

  if (mq.MS_AND_DOWN) return scores;

  return (
    <Fieldset>
      <Fieldset.Legend required>
        {Object.keys(field.value).length === 1 ? 'Score' : 'Scores'}
      </Fieldset.Legend>
      <div className={styles.scores}>{scores}</div>
    </Fieldset>
  );
};

export default Scores;
